import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

export type ContextMenuDividerProps = Omit<ComponentPropsWithoutRef<'hr'>, 'children'> & {
  /** Обернуть в `<li role="presentation">` для использования внутри `.context-menu__list` */
  inList?: boolean;
  /**
   * Вертикальные отступы `var(--space-1)` вокруг линии:
   * при `inList` — класс на `<li>` (`.context-menu__list-item_divider_spaced`);
   * без `inList` — обёртка `.context-menu__divider-wrap_spaced` (панели подменю между блоками).
   */
  listSpacing?: boolean;
};

/** Нативный `<hr>`: линия на всю ширину панели (компенсация горизонтального padding `.context-menu` / `.context-menu_submenu`). */
export function ContextMenuDivider({
  className,
  inList = false,
  listSpacing = false,
  role = 'separator',
  ...rest
}: ContextMenuDividerProps) {
  const hr = <hr {...rest} className={clsx('context-menu__divider', className)} role={role} />;
  if (inList) {
    return (
      <li
        className={clsx(
          'context-menu__list-item',
          'context-menu__list-item_divider',
          listSpacing && 'context-menu__list-item_divider_spaced'
        )}
        role="presentation"
      >
        {hr}
      </li>
    );
  }
  if (listSpacing) {
    return (
      <div className="context-menu__divider-wrap context-menu__divider-wrap_spaced" role="presentation">
        {hr}
      </div>
    );
  }
  return hr;
}
